export const KEY_REDUCER_SYSTEM = "system";
